import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteError } from "../shared/components/RouteError";
import { RoutePending } from "../shared/components/RoutePending";

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
});

/**
 * @purpose Sign in
 * @primary Login form
 * @persona all
 */
export const Route = createFileRoute("/_public/login")({
  validateSearch: (search) => loginSearchSchema.parse(search),
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
